module.exports = __webpack_public_path__ + "static/media/front_corner.56ee0d24.png";